import { Skill } from '../../types/seller';

export const skillsWhitelist = new Set([
    'React expert',
    'React Native expert',
    'React',
    'Node.js expert',
    'Node.js',
    'JavaScript developer',
    'JavaScript',
    'API developer',
    'MongoDB expert',
    'Next.js developer',
    'Next.js',
    'Html5 expert',
    'Html expert',
    'Html',
    'HTML',
    'Web developer',
    'Domain & Hosting expert',
    'API & Integrations',
    'Bug fixes',
    'css3 expert',
    'css expert',
    'Tailwind CSS',
    'shadcn developer',
    'Firebase',
]);

export const sortSkills = (skills: Skill[]): Skill[] => {
    const promoted: Skill[] = [];
    const rest: Skill[] = [];

    for (const skill of skills) {
        if (skillsWhitelist.has(skill.value)) {
            promoted.push(skill);
        } else {
            rest.push(skill);
        }
    }

    return [...promoted, ...rest];
};
